export default class EntityId<E> {

	public constructor (private value: number | null) {}

	public static create<E> () {
		return new this<E>(null);
	}

	public getValue (): number | null {
		return this.value;
	}

	public isNull () {
		return this.value === null;
	}

	public equals (other: EntityId<E>) {
		return this.value === other.getValue();
	}
}


// WEBPACK FOOTER //
// ./code/foundation/domain/EntityId.ts